import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import InstagramIcon from './icons/instagram';
import TwitterIcon from './icons/twiiter';
import gtm from '@/utils/gtm';

const Gift: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('Gift');

    function handleLink(link: string, btnId: string) {
        window.open(link, '_blank');

        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_join_social',
            method: btnId == 'instagram-btn' ? 'Instagram' : 'Twitter',
            position: t('title'),
            button_name: t('footer_item'),
            page_name: 'furusato-tokyo-support-festival',

            __btn_id1: btnId,
            __btn_id2: btnId,
            __btn_type: 'common',
        });
    }

    return (
        <div className={styles.Gift + ' GtmModuleData-section'} data-section-id="gift">
            <div className="lp-layout">
                <div className="title">{t('title')}</div>
                <div className="content">
                    <div className="content-box">
                        <div className="h1-font">{t('left_title')}</div>
                        <div className="h1-font">{t('left_content')}</div>
                        <div className="h2-font">{t('left_date')}</div>
                        <div className="content-line"></div>
                        <div className="h2-font">{t('left_gift')}</div>
                        <div className="h2-font">{t('left_gift_item1')}</div>
                        <div className="h2-font">{t('left_gift_item2')}</div>
                        <div className="h2-font">{t('left_gift_item3')}</div>
                        <div className="h2-font">{t('left_gift_item4')}</div>
                        <div className="content-line"></div>
                        <div className="h2-font">{t('left_method_title')}</div>
                        <div className="h2-font">{t('left_method_item1')}</div>
                        <div className="h2-font">{t('left_method_item2')}</div>
                    </div>
                    <div className="content-box">
                        <div className="h1-font">{t('right_title')}</div>
                        <div className="h1-font">{t('right_content')}</div>
                        <div className="h2-font">{t('right_date')}</div>
                        <div className="content-line"></div>

                        <div className="h2-font">{t('right_gift')}</div>
                        <div className="h2-font">{t('right_gift_item1')}</div>
                        <div className="h2-font">{t('right_gift_item2')}</div>
                        <div className="h3-font">{t('right_gift_item3')}</div>
                        <div className="h3-font">{t('right_gift_item4')}</div>
                        <div className="content-line"></div>
                        <div className="h2-font">{t('right_method_title')}</div>
                        <div className="h2-font">{t('right_method_item1')}</div>
                        <div className="h2-font">{t('right_method_item2')}</div>
                        <div className="h2-font">{t('right_method_item3')}</div>
                    </div>
                </div>

                <div className="footer">
                    <div className="footer-title">{t('footer_title')}</div>
                    <div className="footer-items">
                        <div
                            className="footer-item GtmModuleData-btn-common instagram-btn"
                            data-btn-id="instagram-btn"
                            onClick={() => handleLink('https://bit.ly/4p7WmmV', 'instagram-btn')}
                        >
                            <InstagramIcon />
                            {t('footer_item')}
                        </div>
                        <div
                            className="footer-item GtmModuleData-btn-common twitter-btn"
                            data-btn-id="twitter-btn"
                            onClick={() => handleLink('https://bit.ly/4p4WweZ', 'twitter-btn')}
                        >
                            <TwitterIcon />
                            {'EcoFlowJapan'}
                        </div>
                    </div>

                    <div className="footer-desc">XまたはInstagramのどちらからでもご応募いただけます。</div>
                </div>
            </div>
        </div>
    );
};

export default Gift;
